import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  #installmentsCtaWired = false;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    this.#setupInstallmentsClose();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd=event=>{const data=event?.detail?.data;if(data?.didError||data?.source==="cart-items-component"||this.refs?.dialog?.open)return;this.open()};

  open() {
    this.showDialog();
    this.#setupInstallmentsClose();
  }

  close() {
    this.closeDialog();
  }

  #setupInstallmentsClose() {
    if (this.#installmentsCtaWired) return;

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');

      if (!cta) return;

      cta.addEventListener('click', () => {
        this.close();
      });

      this.#installmentsCtaWired = true;
    }).catch(() => {
      // Não deixa um erro secundário quebrar o drawer.
    });
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
